import axios from 'axios';
import get from 'lodash/get';
import { getAuthV2Url, getEditionsAddonsQueryById } from '../configs/authV2';

export default class AuthV2Service {
  constructor() {
    'ngInject';
  }

  async getEditions() {
    try {
        const { data } = JSON.parse(localStorage.getItem('idToken'));

        return await axios.post(
            getAuthV2Url(),
            {
                query: getEditionsAddonsQueryById
            },
            {
                headers: {
                Authorization: `Bearer ${data}`,
                'Content-Type': 'application/json',
                },
            },
        );
    } catch(err) {
        throw new Error(get(err, 'message') || err);
    }
  }
}
